import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";

export const DrawerList = [
  {
    icon: NotificationsNoneIcon,
    selectedIcon: NotificationsIcon,
    name: "Dashboard",
    value: 1,
    navigate: "/landing/activity",
    roles: ["ADMIN", "STUDENT"],
  },
  {
    icon: WorkspacePremiumOutlinedIcon,
    selectedIcon: WorkspacePremiumIcon,
    name: "Courses",
    value: 2,
    navigate: "/landing/certification",
    roles: ["ADMIN", "STUDENT", "CREATOR"],
  },
  {
    icon: LocalLibraryOutlinedIcon,
    selectedIcon: LocalLibraryIcon,
    name: "Classroom",
    value: 3,
    navigate: "/landing/classroom",
    roles: ["ADMIN", "STUDENT", "CREATOR"],
  },
  // {
  //   icon: WorkOutlineOutlinedIcon,
  //   name: "Jobs",
  //   value: 4,
  //   navigate: "/landing/jobs",
  // roles: ["ADMIN", "STUDENT", "CREATOR"],

  // },
  {
    icon: AccountCircleOutlinedIcon,
    selectedIcon: AccountCircleIcon,
    name: "Profile",
    value: 5,
    navigate: "/landing/profile",
    roles: ["ADMIN", "STUDENT"],
  },
  {
    icon: SettingsOutlinedIcon,
    selectedIcon: SettingsIcon,
    name: "Settings",
    value: 6,
    navigate: "/landing/settings",
    roles: ["ADMIN", "STUDENT"],
  },
  {
    icon: AddToPhotosIcon,
    selectedIcon: AddToPhotosIcon,
    name: "Content",
    value: 7,
    navigate: "/landing/Content",
    roles: ["ADMIN", "CREATOR"],
  },
  // {
  //   icon: TopicIcon,
  //   selectedIcon: TopicIcon,
  //   name: "Create Content",
  //   value: 7,
  //   navigate: "/landing/CreateCourseAndModule",
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   icon: AssessmentIcon,
  //   selectedIcon: AssessmentIcon,
  //   name: "Create Assessment",
  //   value: 8,
  //   navigate: "/landing/CreateAssessment",
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   icon: AssessmentIcon,
  //   selectedIcon: AssessmentIcon,
  //   name: "Create Final Assessment",
  //   value: 9,
  //   navigate: "/landing/CreateFinalAssessment",
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   icon: MergeIcon,
  //   selectedIcon: MergeIcon,
  //   name: "Map Assessment",
  //   value: 10,
  //   navigate: "/landing/MapAssessment",
  //   roles: ["ADMIN", "CREATOR"],
  // },
];

export const TourData = [
  {
    value: 1,
    head: "Welcome to Dashboard!",
    content: [
      "This is your central hub. Get an overview of your learning journey, track progress with detailed analytics, and stay updated with upcoming deadlines and announcements.",
    ],
  },
  {
    value: 2,
    head: "Explore your Courses! ",
    content: [
      "This is where you’ll find the complete list of courses available to you. Browse, enroll, and start learning at your own pace!",
    ],
  },
  {
    value: 3,
    head: "Step into your Classroom!",
    content: [
      "Access recorded sessions, complete quick assessments, and take the final assessment to track your learning, grade your score, and earn certifications.",
    ],
  },
  {
    value: 4,
    head: "Your Profile, Your Identity!",
    content: [
      "Add details about yourself, including your work experience, achievements, and skills. Showcase your journey and keep track of your growth.",
    ],
  },
  {
    value: 5,
    head: "Control your Experience!",
    content: [
      " Manage your preferences, notifications, and account details here. Tailor the platform to suit your needs.",
    ],
  },
  // {
  //   value: 6,
  //   head: "Settings",
  //   content: [
  //     " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  //     " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  //   ],
  // },
];

